module.exports = __webpack_public_path__ + "img/upgrade-img-4.8ac4224f.png";